// extracted by mini-css-extract-plugin
export default {"card":"style_card__ZMgK8","front":"style_front__uWPvT","back":"style_back__rlDhe","bodyContainer":"style_bodyContainer__ODg3o"};